<template>
  <Breadcrumb :loading="breadcrumbs.loading" :links="breadcrumbs.links" />
</template>

<script>
import { computed, watch } from "@vue/composition-api";
import Breadcrumb from "@/components/display/Breadcrumb";
import store from "@/store";

export default {
  name: "GlobalBreadcrumb",
  components: {
    Breadcrumb,
  },
  setup() {
    const breadcrumbs = computed(() => {
      return store.getters["nav/getBreadcrumbs"];
    });

    watch(breadcrumbs, (bc) => {
      if (bc.loading === false && bc.links && bc.links.length) {
        const lastItem = bc.links[bc.links.length - 1];
        const title = `${lastItem.name} | Nexcess Portal`;
        document.title = title;
      } else {
        document.title = "Nexcess Portal";
      }
    });

    return {
      breadcrumbs,
    };
  },
};
</script>

<style lang="scss">
@import "~@/styles/variables";
</style>
